export const CI_UNHAPPY_WIDGETS_FF = 'call-intel:dashboard-widgets:unhappy-calls';
